//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getRetailAssistantLoginAuditList, postRetailAssistantLoginAudit, getRetailAssistantLoginDel } from '@/api/bairun/userInfo'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
export default {
  name: 'BeirunUserWeChat',
  components: {},
  data: function data() {
    return {
      path: window.origin + '/' + process.env.VUE_APP_BASE_API,
      loading: true,
      activeName: 'auditing',
      auditStatus: false,
      searchInfo: {},
      tableData: [],
      status: 1,
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      form: {}
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    // 搜索
    onSubmit: function onSubmit() {
      this.getTableData();
    },
    // 点击菜单
    handleClick: function handleClick(tab) {
      if (tab.index == 0) {
        this.auditStatus = false;
        this.status = 1;
      } else {
        this.auditStatus = true;
        this.status = 2;
      }

      this.getTableData();
    },
    // 获取微信用户审核列表
    getTableData: function getTableData() {
      var _this = this;

      var obj = {
        'page': this.page,
        'pageSize': this.pageSize,
        'auditStatus': this.status,
        'appSource': this.activeName == 'auditing' ? '' : this.activeName,
        'nickname': this.searchInfo.nickname,
        'userName': this.searchInfo.userName
      };
      getRetailAssistantLoginAuditList(obj).then(function (res) {
        if (res.code == 0) {
          _this.tableData = res.data.list;
          _this.total = res.data.total;
          _this.loading = false;
        }
      }, function (err) {});
    },
    // 同意
    agree: function agree(row) {
      this.form = row;
      this.dialogFormVisible = true;
    },
    // 同意确认
    agreeClick: function agreeClick() {
      this.postLoginAudit(this.form.ID, 2);
    },
    // 不同意
    disagree: function disagree(row) {
      this.postLoginAudit(row.ID, 3);
    },
    // 删除用户
    cancel: function cancel(row) {
      var _this2 = this;

      var obj = {
        'ID': row.ID
      };
      getRetailAssistantLoginDel(obj).then(function (res) {
        _this2.getTableData();
      }, function (err) {});
    },
    // 处理微信用户审核
    postLoginAudit: function postLoginAudit(id, status) {
      var _this3 = this;

      var obj = {
        'ID': id,
        'auditStatus': status
      };

      if (status == 2) {
        obj['userName'] = this.form.userName;
      }

      postRetailAssistantLoginAudit(obj).then(function (res) {
        if (res.code == 0) {
          console.log(res);

          _this3.getTableData();

          _this3.dialogFormVisible = false;
        }
      }, function (err) {});
    },
    // 分页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    }
  }
};